import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getUserPaymentCredentials = () =>
  call(websocketFetch, 'get_user_payment_credentials');
